type AvatarSourceUser = {
  image?: string | null;
  imageStorageKey?: string | null;
};

/**
 * The reference `UserAvatarDisplay` resolves (#5904). A profile photo's
 * storage key resolves only for its uploader, but saving the photo also
 * writes the same image as the public `image` URL. Prefer that URL so every
 * member sees the photo, then the key, then a legacy `_storage` id in `image`.
 */
export function pickUserAvatarSource(
  user: AvatarSourceUser | null | undefined
): string | null {
  const image = user?.image?.trim() || null;
  if (image && /^https?:\/\//i.test(image)) return image;
  return user?.imageStorageKey?.trim() || image;
}

/** Stable shape identity, separate from the name exposed to readers. */
export function userAvatarSeed(
  user: { _id?: string; email?: string | null } | null | undefined,
  fallback: string
): string {
  if (user?._id) return user._id;
  if (!user?.email) return fallback;
  let hash = 2166136261;
  for (const character of user.email.trim().toLowerCase()) {
    hash = Math.imul(hash ^ character.charCodeAt(0), 16777619);
  }
  return `member-${(hash >>> 0).toString(16)}`;
}
